"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var ActionFilter = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M5.5 5h13c.85 0 1.5.65 1.5 1.5S19.35 8 18.5 8h-13C4.65 8 4 7.35 4 6.5S4.65 5 5.5 5ZM7.5 11h9c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5h-9c-.85 0-1.5-.65-1.5-1.5S6.65 11 7.5 11Zm3 6h3c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5h-3c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5Z" }))); };
exports.default = ActionFilter;
